
import { inject, ref, shallowRef } from '@vue/composition-api';
import { Button, Note, StatusBlock } from '05-ui-kit';
import scrollIntoView from 'smooth-scroll-into-view-if-needed';
import { defineComponent, useContext, useMeta, useRoute, useRouter } from '@nuxtjs/composition-api';
import TSHybridPagination from '~/components/ts-components/TSHybridPagination/TSHybridPagination.vue';
import type { EmitteryType } from '~/plugins/emitter';
import type QuestionType from '~/type/Question';
import type { ProductExtended } from '~/type/product/Product';
import link from '~/helper/canonical';
import wrapFunc from '~/helper/wrapFunc';
import AnswerForm from '~/components/product/AnswerForm/AnswerForm.vue';
import ViewportToogle from '~/components/ViewportToogle/ViewportToogle.vue';
import { useReportStore } from '~/store/modal/report';
type RequestTypeAddQuestion = Awaited<ReturnType<typeof context.$api.question.addQuestion>>;
type RequestTypeAddComment = Awaited<ReturnType<typeof context.$api.question.addComment>>;
const __sfc_main = defineComponent({
  head: {}
});
__sfc_main.props = {
  response: {
    key: "response",
    required: true,
    type: Object
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const emitter = inject<EmitteryType>('emitter')!;
  const context = useContext();
  const isActive = ref<boolean | string | (string | null)[]>(false);
  const list = ref<QuestionType[]>();
  const route = useRoute();
  const router = useRouter();
  const startQuestion = shallowRef<HTMLDivElement>();
  const {
    enableReport
  } = useReportStore();
  if (route.value?.query?.isActive) {
    // Открывает форму с вопросом, при переходе с ссылки "задать вопрос" на главной странице товара.
    isActive.value = route.value.query.isActive;
    // Очищает query из url, чтобы после перезагрузки страницы форма не появлялась снова.
    router.replace({
      query: {}
    });
  }
  function addQuestionHandler({
    response
  }: {
    response: RequestTypeAddQuestion;
  }) {
    Array.isArray(list.value) ? list.value.push(response?.result) : list.value = [response?.result];
  }
  function addAnswerHandler(id: string, {
    result
  }: RequestTypeAddComment) {
    const question = list.value?.find((item: QuestionType) => item.id === id);
    if (question) {
      if (Array.isArray(question.answer)) question.answer.push(result);else question.answer = [result];
    }
  }
  function onScrollTop() {
    if (startQuestion.value) {
      scrollIntoView(startQuestion.value, {
        block: 'start'
      });
    }
  }
  useMeta(() => ({
    title: `${props.response?.product?.name} все вопросы покупателей 05 о товаре ${props.response?.product?.code}`,
    meta: [{
      hid: 'description',
      name: 'description',
      content: `05 предлагает ознакомиться с вопросами и ответами на ${props.response?.product?.name} ${props.response?.product?.code}`
    }, ...(props.response?.product?.metaRobot?.question ? [] : [{
      name: 'robots',
      content: 'noindex'
    }])],
    ...link({
      exclude: [],
      data: {
        route,
        config: context.$config
      }
    })
  }));
  return {
    wrapFunc,
    emitter,
    isActive,
    list,
    startQuestion,
    enableReport,
    addQuestionHandler,
    addAnswerHandler,
    onScrollTop
  };
};
__sfc_main.components = Object.assign({
  Button,
  AnswerForm,
  StatusBlock,
  Note,
  ViewportToogle,
  TSHybridPagination
}, __sfc_main.components);
export default __sfc_main;
